/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleSelector_itemSearch = {
    readonly browseContentModule: {
        readonly moduleType: string | null;
        readonly " $fragmentRefs": FragmentRefs<"SbRespContentModuleRegular_browseContentModule" | "SbSharedContentModuleBanner_browseContentModule" | "SbSharedContentModulePromo_browseContentModule" | "SbSharedContentModuleIconicDesign_browseContentModule" | "SbSharedContentModuleBannerTiles_browseContentModule">;
    } | null;
    readonly " $refType": "SbRespContentModuleSelector_itemSearch";
};
export type SbRespContentModuleSelector_itemSearch$data = SbRespContentModuleSelector_itemSearch;
export type SbRespContentModuleSelector_itemSearch$key = {
    readonly " $data"?: SbRespContentModuleSelector_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespContentModuleSelector_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespContentModuleSelector_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "browseContentModule",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "contentModuleId",
          "variableName": "contentModuleId"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "moduleType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbRespContentModuleRegular_browseContentModule",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleBanner_browseContentModule",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedContentModulePromo_browseContentModule",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleIconicDesign_browseContentModule",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleBannerTiles_browseContentModule",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'ce690f9ed8a09efafc65abebe9a170bc';
export default node;
